import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

import { useUser } from "@/features/auth/hooks/use-user";
import { SessionTypesTab } from "@/features/booking/modules/session-types/session-types-tab";
import { SetupActionsSlot } from "@/features/booking/modules/setup-actions/setup-actions";
import { OfferShell } from "@/features/shop/modules/offer-shell/offer-shell";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/offer/")({
  loader: () => ({ crumb: m.offer_tab_services() }),
  validateSearch: z.object({
    /** Opens the editor on a new visit or subscription. */
    create: z.enum(["visit", "subscription"]).optional().catch(undefined),
  }),
  component: ServicesPage,
});

/** The services tab. Everyone can read it; only admins change it. */
function ServicesPage() {
  const { hasPermission } = useUser();
  const { create } = Route.useSearch();
  const navigate = Route.useNavigate();
  const [actionsNode, setActionsNode] = useState<HTMLElement | null>(null);

  return (
    <OfferShell actions={<div ref={setActionsNode} className="contents" />}>
      <SetupActionsSlot.Provider value={actionsNode}>
        <SessionTypesTab
          canEdit={hasPermission("manage", "booking_settings")}
          create={create}
          onCreateHandled={() => void navigate({ search: {}, replace: true })}
        />
      </SetupActionsSlot.Provider>
    </OfferShell>
  );
}
